import { Item } from 'Components/Grid';
import HistoryRow from 'Components/HistoryRow';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import * as React from 'react';
import { formatPartialDate } from 'Utility/date';
import { filterDocumentsByType, sortDocumentsDescending } from 'Utility/documentHandling';
import { newButton } from '../../../../utils/functions';

import type { IHistoryContext } from 'Containers/FormContextHandler';

const DEFAULT_DOCUMENTS: IDocumentWithTypeV2<'uhdrsConfidenceIndex'>[] = [];
const UNHDRSHistory = ({
  documents = DEFAULT_DOCUMENTS,
  startEdit,
  view,
  fm,
}: IHistoryContext<IDocumentWithTypeV2<'uhdrsConfidenceIndex'>>): React.JSX.Element => {
  return (
    <HistoryRow
      headerText={fm('diagnosis.huntington.uhdrs.history.header')}
      rowButton={
        startEdit
          ? newButton('uhdrsConfidenceIndex', startEdit({}, 'uhdrsConfidenceIndex'), 'general.new', 15)
          : undefined
      }
    >
      <HistoryRowListing
        documents={filterDocumentsByType(documents, ['uhdrsConfidenceIndex']).sort(sortDocumentsDescending)}
        headers={
          <>
            <Item xs={2}>{fm('general.date')}</Item>
            <Item xs={10}>{fm('diagnosis.huntington.uhdrs.history.index')}</Item>
          </>
        }
        contentFormat={d => (
          <>
            <Item xs={2} style={{ fontWeight: '600' }}>
              {d.date && formatPartialDate(d.date)}
            </Item>
            <Item xs={7}>{d.index ? `${d.index} - ` + fm(`diagnosis.huntington.uhdrs.form.opts.${d.index}`) : ''}</Item>
            <Item xs={3}>
              {startEdit ? <HistoryRowControls document={d} startEdit={startEdit} view={view} /> : null}
            </Item>
          </>
        )}
      />
    </HistoryRow>
  );
};

export default UNHDRSHistory;
